import React from "react";
import ReactDOM from "react-dom/client";
import store from "./store";
import "./App.scss";
import { Provider } from "react-redux";
import Router from "./router";
import { RouterProvider } from "react-router-dom";
import Loading from "./routes/Loading";
import * as Sentry from "@sentry/react";

export const loggingClient = (): Sentry.BrowserClient => {
  const integrations = Sentry.getDefaultIntegrations({}).filter((defaultIntegration) => {
    return !["BrowserApiErrors", "Breadcrumbs", "GlobalHandlers"].includes(
      defaultIntegration.name
    );
  });

  const client = new Sentry.BrowserClient({
    dsn: "https://83f23afb2b7081a1758a5fcebea1f94b@o1132036.ingest.us.sentry.io/4507528896380928",
    transport: Sentry.makeFetchTransport,
    stackParser: Sentry.defaultStackParser,
    integrations: integrations,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
  });

  return client;
};

export const loggingScope = (): Sentry.Scope => {
  const client = loggingClient();
  const scope = new Sentry.Scope();
  scope.setClient(client);

  return scope;
};

const client = loggingClient();
client.init();

export const Logger = () => {
  const scope = loggingScope();

  const api = {
    log: (message: string) => {
      console.log(message);
      scope.captureMessage(message);
    },
    error: (message: string) => {
      console.error(message);
      scope.captureMessage(message);
    },
  };

  return api;
};

ReactDOM.createRoot(
  document.getElementById("surestore-rapidstor-frontend") as HTMLElement
).render(
  // <React.StrictMode>
  <Provider store={store}>
    <RouterProvider router={Router} fallbackElement={<Loading />} />
  </Provider>
  // </React.StrictMode>
);
